module.exports = __webpack_public_path__ + "static/media/pic_1.a5d1f83e.png";